import { writable } from 'svelte/store';

export const recipes = writable([]);
export const produce = writable([]);
export const isReady = writable(false);
export const isLoggedIn = writable(false);

export const loadProduce = async () => {
    let result = await fetch("/api/produce");
    let unsorted = await result.json();
    unsorted.sort((a, b) => a.name > b.name);
    produce.set(unsorted);
}
